export class Image
{
	images = document.querySelectorAll('[data-s~="Image"]')
    swiper = document.querySelector('[data-s~="Carousel"][data-uuid~="f042975d-85f9-42bd-b8f9-28a7d5d7577a"]')
    index = 1
    speed = 0
    runCallbacks = false

    slide()
    {
        this.swiper.swiper.slideTo(this.index-1, this.speed, this.runCallbacks)
    }

    watch()
    {
        this.images.forEach(e => {
            e.addEventListener("click", () => {
                this.index = e.getAttribute("data-index")
                this.slide()
            })
        })
    }
}
